import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=41bfcb26&"
import script from "./SidebarNav.vue.ts?vue&type=script&lang=ts&"
export * from "./SidebarNav.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports